module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded,
      "caption": this.isLoaded ? 'Свернуть' : 'Загрузить',
      "expandable": true,
      "printActions": _vm.printActions
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c('div', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2"
    }
  }, [_vm._v(" Финансовая отчетность (тыс.р.)")])])]), _c('br')])]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    staticClass: "pt-0"
  }, [(_vm.isLoaded) ? _c('div', [_c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    attrs: {
      "align": "left",
      "colspan": _vm.years.length
    }
  }, [_vm._v("Бухгалтерский баланс")])]), _vm._v(" "), _c('tr', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatHeaders())
    }
  }), _vm._v(" "), _vm._l((this.getPartItems(0, 20000)), function(item) {
    return [(item) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": _vm.years.length
      }
    }, [_c('b', [_vm._v(_vm._s(Math.trunc(item.code / 10)))]), _vm._v(" " + _vm._s(item.name))])]) : _vm._e(), _vm._v(" "), (item) ? _c('tr', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatValues(item))
      }
    }) : _vm._e()]
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    attrs: {
      "align": "left",
      "colspan": _vm.years.length
    }
  }, [_vm._v("Отчет о прибылях и убытках")])]), _vm._v(" "), _c('tr', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatHeaders())
    }
  }), _vm._v(" "), _vm._l((this.getPartItems(20000, 30000)), function(item) {
    return [(item) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": _vm.years.length
      }
    }, [_c('b', [_vm._v(_vm._s(Math.trunc(item.code / 10)))]), _vm._v(" " + _vm._s(item.name))])]) : _vm._e(), _vm._v(" "), (item) ? _c('tr', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatValues(item))
      }
    }) : _vm._e()]
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    attrs: {
      "align": "left",
      "colspan": _vm.years.length
    }
  }, [_vm._v("Отчет об изменениях капитала")])]), _vm._v(" "), _c('tr', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatHeaders())
    }
  }), _vm._v(" "), _vm._l((this.getPartItems(30000, 40000)), function(item) {
    return [(item) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": _vm.years.length
      }
    }, [_c('b', [_vm._v(_vm._s(Math.trunc(item.code / 10)))]), _vm._v(" " + _vm._s(item.name))])]) : _vm._e(), _vm._v(" "), (item) ? _c('tr', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatValues(item))
      }
    }) : _vm._e()]
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    attrs: {
      "align": "left",
      "colspan": _vm.years.length
    }
  }, [_vm._v("Отчет о движении денежных средств")])]), _vm._v(" "), _c('tr', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatHeaders())
    }
  }), _vm._v(" "), _vm._l((this.getPartItems(40000, 50000)), function(item) {
    return [(item) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": _vm.years.length
      }
    }, [_c('b', [_vm._v(_vm._s(Math.trunc(item.code / 10)))]), _vm._v(" " + _vm._s(item.name))])]) : _vm._e(), _vm._v(" "), (item) ? _c('tr', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatValues(item))
      }
    }) : _vm._e()]
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    attrs: {
      "align": "left",
      "colspan": _vm.years.length
    }
  }, [_vm._v("Отчет о целевом использовании полученных средств")])]), _vm._v(" "), _c('tr', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatHeaders())
    }
  }), _vm._v(" "), _vm._l((this.getPartItems(60000, 70000)), function(item) {
    return [(item) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": _vm.years.length
      }
    }, [_c('b', [_vm._v(_vm._s(Math.trunc(item.code / 10)))]), _vm._v(" " + _vm._s(item.name))])]) : _vm._e(), _vm._v(" "), (item) ? _c('tr', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatValues(item))
      }
    }) : _vm._e()]
  })], 2)]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de68d55c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/FinPanel.vue
// module id = 1083
// module chunks = 1